/* eslint-disable react/style-prop-object */
/* eslint-disable max-len */
import { useTheme } from '@material-ui/core';
import React, { CSSProperties, useMemo } from 'react';


export interface InfoIconProps {
    readonly className?: string | undefined;
    readonly style?: CSSProperties | undefined;
    readonly background?: string | undefined;
    readonly foreground?: string | undefined;
}


/**
 * This is a React component what wrap the warning's SVG image. This allow us to use it in other React components and customize it.
 */
export const InfoIcon: React.FC<InfoIconProps> = (props: InfoIconProps) => {

    const theme = useTheme();

    // Give the warning image an instanceId so that we append the instanceId to the SVG elements' IDs to make them unique. These are HTML Element ID
    // so if we don't give them unique IDs, we can't create multiple instances of this WarningIcon component.
    const instanceId = useMemo(() => {
        return Math.random() * 1000 * Date.now();
    }, []);


    const backgroundColor = useMemo((): string => {
        // Get the color from props, use color "#ff0a31" as default if color is not provided
        return props.background ?? theme.palette.info.main;
    }, [props.background, theme.palette.info.main]);


    const foregroundColor = useMemo((): string => {
        return props.foreground ?? theme.palette.info.contrastText;
    }, [props.foreground, theme.palette.info.contrastText]);


    return (
        <svg
            className={props.className}
            style={props.style}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 650 650"
            id={`${instanceId}`}
        >
            <circle
                cx="320"
                cy="320"
                r="314"
                style={{
                    fill: '#fff',
                }}
            />
            <circle
                cx="316"
                cy="320"
                r="281"
                style={{
                    fill: backgroundColor,
                }}
            />
            <rect
                style={{
                    fill: `${foregroundColor}`,
                }}
                x="278"
                y="253"
                width="84"
                height="272"
                rx="30"
                ry="30"
            />
            <circle
                style={{
                    fill: `${foregroundColor}`,
                }}
                cx="320"
                cy="155"
                r="50"
            />
        </svg>
    );
};
